<script lang="ts">
    import type {Writable} from 'svelte/store';
    import {getContext, onDestroy} from 'svelte';
    import {getValueEditorLabelContext} from '../../value-editors/internal/label/value-editor-label-context';

    /*
    headless-ui does not allow using custom ids for its listbox,
    and it manages aria-labelledby attributes, preventing us doing it manually.
    it also does not allow for custom label to be outside its container component
    to provide correct label information for select build with headless-uis listbox,
    we need to tap its internal API via svelte context.
    basically this component acts as listbox label component,
    but instead of rendering label it registers id of our existing label element
    * */

    const LISTBOX_CONTEXT_NAME = 'headlessui-listbox-context';
    const api: Writable<any> = getContext(LISTBOX_CONTEXT_NAME);
    if (!api) {
        throw new Error(
            '<DropdownListboxLabelProvider /> is missing a parent <Listbox /> component.'
        );
    }
    const labelRef: Writable<Pick<HTMLLabelElement, 'id'> | null> = $api.labelRef;
    const buttonRef: Writable<HTMLButtonElement | null> = $api.buttonRef;

    const labelContext = getValueEditorLabelContext();

    let subscription;
    if(!!labelContext) {

        labelRef.set({id: labelContext.labelId});
        labelContext.config.update((currentConfig) => ({...currentConfig, disableForAttribute: true}));
        subscription = labelContext.clickEvent$.subscribe(() => $buttonRef?.focus({ preventScroll: true }));
    }

    onDestroy(() => {
        subscription?.unsubscribe();
    });
</script>
